import React from 'react';
import './App.css';


function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Exportaciones de café</h1>
        <p>
          We do stuff
        </p>
      </header>
    </div>
  );
}

export default App;
